var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'device-preview-box',
    _vm.isInternalPage && 'device-preview-box--internal-page'
  ]},[_c('div',{staticClass:"device-preview-box__device-preview"},[(_vm.isInternalPage)?_c('ButtonTabsV2',{attrs:{"activeTab":_vm.device,"tabs":_vm.devices,"color":_vm.themeTextColor},on:{"change":_vm.handleChangeTab}}):_c('ButtonTabs',{attrs:{"title":_vm.$t((_vm.tPrefix + ".tabLabel")),"activeTab":_vm.device,"tabs":_vm.devices,"color":_vm.isNewOnlineSignup ? '#10222D' : _vm.themeTextColor,"theme":_vm.isNewOnlineSignup ? 'dark' : 'light'},on:{"change":_vm.handleChangeTab}})],1),(
      _vm.isNewOnlineSignup &&
        _vm.device === 'mobile' &&
        _vm.formData.previewState !== 'welcomeMessage'
    )?_c('div',{class:["device-preview-box__content--two-preview"]},[_c('div',{class:[
        'device-preview-box__content',
        ("device-preview-box__content--" + _vm.placementDirection)
      ]},[_c('MockupWidgetPreview',{attrs:{"device":_vm.device,"widgetConfigProps":Object.assign({}, _vm.formData,
          {previewState:
            _vm.formData.previewState !== 'popover' ? _vm.formData.previewState : ''})}})],1),_c('div',{class:[
        'device-preview-box__content',
        ("device-preview-box__content--" + _vm.placementDirection)
      ]},[_c('MockupWidgetPreview',{attrs:{"device":_vm.device,"widgetConfigProps":Object.assign({}, _vm.formData, {previewState: 'popover'})}})],1)]):_c('div',{class:[
      'device-preview-box__content',
      ("device-preview-box__content--" + _vm.device),
      ("device-preview-box__content--" + _vm.placementDirection)
    ]},[_c('MockupWidgetPreview',{attrs:{"device":_vm.device,"widgetConfigProps":_vm.formData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }